const actions = {
  set: 'SET::SET_USER',
  fetch: 'FETCH::FETCH_USER'
}

export const setUser = user => ({ type: actions.set, user })
export const fetchUser = () => ({ type: actions.fetch })

export default actions
